/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const React = require('react');
const Dropdown = require('@andes/dropdown');
const Switch = require('@andes/switch');
const TextField = require('@andes/textfield');
const Message = require('@andes/message');
const Card = require('@andes/card');
const FeedbackCaution16 = require('@andes/icons/FeedbackCaution16');
const Tooltip = require('@andes/tooltip');
const Slider = require('@andes/slider');
const RadioButton = require('@andes/radio-button');
const Info20 = require('@andes/icons/Info20');
const FeedbackCaution12 = require('@andes/icons/FeedbackCaution12');
const Checkbox = require('@andes/checkbox');
const CheckboxList = require('@andes/checkbox-list');

const { CheckboxListItem } = CheckboxList;
const { DropdownItem } = Dropdown;
const { RadioGroup } = RadioButton;
const { useLiveDemoContext } = require('./Provider/liveDemoContext');
const GenericCollapse = require('./components/GenericCollapse');
const { useDebounce } = require('../utils/debounce');
const { users } = require('../utils/utils');
const { getEventTracker } = require('../../../event-tracker');

const Properties = ({ componentProps, isMobile, i18n, liveDemoId, lang }) => {
  const Tracker = getEventTracker();

  const { options, optionsDescription, advancedOptions, advancedOptionsDescription, mobileDescription } = componentProps;
  const { setFormData, formData, behaviorData } = useLiveDemoContext();
  const [selectedInput, setSelectedInput] = React.useState();

  const [textInputs, setTextInputs] = React.useState({});
  const finalTextInputs = useDebounce(textInputs, 1000);

  const [sliderInputs, setSliderInputs] = React.useState({});
  const [sliderInput, setSliderInput] = React.useState({});
  const finalSliderInputs = useDebounce(sliderInputs, 1000);

  React.useEffect(() => {
    window?.Prism?.highlightAll();
  }, [selectedInput, formData]);

  function updateState(state, newValue) {
    setFormData(prev => ({
      ...prev,
      [state]: newValue,
    }));
  }

  function updateStateForText(state, newValue) {
    setTextInputs({
      ...textInputs,
      [state]: newValue,
    });
  }

  function updateStateForSlider(state, newValue) {
    setSliderInputs({
      ...sliderInputs,
      [state]: newValue,
    });
  }

  const shouldNotRenderConditionalRenderInput = (conditionalRender) => !conditionalRender
    .map((condition) => {
      if (Array.isArray(condition.expectedValue) && Array.isArray(formData[condition.inputId])) {
        let isConditionInArray = false;
        formData[condition.inputId].forEach((cond) => {
          if (condition.expectedValue.includes(cond)) {
            isConditionInArray = true;
          }
        });
        return isConditionInArray;
      }

      if (Array.isArray(condition.expectedValue)) {
        return condition.expectedValue.includes(formData[condition.inputId]);
      }

      return formData[condition.inputId] === condition.expectedValue;
    })
    .every((condition) => condition === true);

  const shouldRenderRequired = (propRequired) => {
    const propId = propRequired?.id;
    const propValuesId = propRequired?.items
      ?.filter((item) => (item?.conditionalRender ? !shouldNotRenderConditionalRenderInput(item?.conditionalRender) : true))
      ?.map((item) => item?.id);
    const response = shouldNotRenderConditionalRenderInput([
      {
        inputId: propId,
        expectedValue: propValuesId,
      },
    ]);
    return response;
  };


  function trackingAdvancedSettings(setting, value) {
    const trackMap = {
      customVariables: 'CHANGED_CUSTOM_CONFIG_VARIABLES',
      customTexts: 'CHANGED_CUSTOM_TEXT_VARIABLES',
      payerInfo: 'CONFIGURED_INICIALIZATION',
      headerColor: 'CHANGED_HEADER_COLOR',
      elementsColor: 'CHANGED_ELEMENTS_COLOR',
    };

    const track = trackMap[setting];

    track
      ? Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/${track.toLowerCase()}`, value)
      : console.trace('Unknown track setting passed to trackingAdvancedSettings: ', setting);
  }

  React.useEffect(() => {
    setFormData(prev => ({
      ...prev,
      ...finalTextInputs,
    }));
  }, [finalTextInputs]);

  React.useEffect(() => {
    if (Object.keys(sliderInput).length !== 0 && finalSliderInputs !== undefined) {
      Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/slider_${sliderInput.name}`, sliderInput.value);
      setSliderInput('');
    }
    setFormData(prev => ({
      ...prev,
      ...finalSliderInputs,
    }));
  }, [finalSliderInputs]);


  const settingComponents = {
    switch: (option) => (
      <div className={`live-settings-container__switch prop-size--${option?.width || 50}`}>
        <Switch
          label={option?.label}
          alt={formData[option.id] ? i18n.gettext('Ocultar') : i18n.gettext('Mostrar')}
          disabled={behaviorData?.disabledComponents?.includes(option?.id)}
          onChange={(event) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/switch_${option?.trackingLabel?.toUpperCase()}`, event.target.checked?.toString());
            updateState(option.id, event.target.checked);
          }}
          defaultChecked={option?.defaultValue}
        />
        {(option?.tooltipContent && !isMobile) && (
          <div className="live-settings-container__tooltip">
            <Tooltip
              content={option?.tooltipContent}
              side="right"
              type="highlight"
              trigger="hover"
              closable
            >
              <Info20 color="var(--andes-color-blue-500)" />
            </Tooltip>
          </div>
        )}
      </div>
    ),

    dropdown: (option) => (
      (!(option?.hide) && !(option?.conditionalRender?.length && shouldNotRenderConditionalRenderInput(option?.conditionalRender))) && (
      <div className={`live-settings-container__dropdown prop-size--${option?.width || 50}`} style={option.style || {}}>
        <div className="live-settings-container__dropdown-title">
          <span className="live-settings--title">{option?.label}</span>
          {(option?.tooltipContent && !isMobile) && (
            <Tooltip
              className="homologator-header__tooltip"
              content={option?.tooltipContent}
              side="right"
              type="highlight"
              trigger="hover"
              showCloseButton
            >
              <Info20 color="var(--andes-color-blue-500)" />
            </Tooltip>
          )}
        </div>
        <Dropdown
          type="form"
          placeholder={option?.placeholder}
          defaultValue={formData[option.id] && !option?.defaultValue ? formData[option.id] : option?.defaultValue}
          message={option?.message}
          helper={option?.helper}
          width={option?.width || 50}
          menuAlignment="bottom"
          disabled={behaviorData?.disabledComponents?.includes(option?.id)}
          onChange={(event, value) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/select_${option?.trackingLabel?.toLowerCase()}`, option?.items?.find(item => item.value === value).siteId || value);
            updateState(option.id, value);
          }}
          menuMaxHeight={222}
        >
          {option?.items.map((item, i) => (
            <DropdownItem
              key={`${item?.value}-${i}`}
              value={item?.value}
              alt={i18n.gettext(item?.primary)}
              title={
                (
                  <div className="live-settings-container__dropdown-item">
                    {item?.icon && (
                      <div className="live-settings-container__dropdown-item--image">
                        {item?.icon}
                      </div>
                    )}
                    <div className="live-settings-container__dropdown-item--text">
                      <span>{item?.primary}</span>
                    </div>
                  </div>
                )
              }
            />
          ))}
        </Dropdown>
      </div>
      )
    ),

    textfield: (option) => (
      <div className={`live-settings-container__textfield prop-size--${option?.width || 50}`} style={option.style || {}}>
        <div className="live-settings-container__textfield-title">
          <span className="live-settings--title">
            {option?.label}
            {option?.tooltipContent && (
              <div className="live-settings-container__textfield-tooltip">
                <Tooltip type="highlight" content={option?.tooltipContent}>
                  <Info20 color="var(--andes-color-blue-500)" />
                </Tooltip>
              </div>
            )}
          </span>
          <a href={`/developers/${lang}/${option?.linkUrl}`} rel="noopener noreferrer" target="_blank">{option?.linkDescription}</a>
        </div>
        {selectedInput === option?.id || !option?.isCode ? (
          <>
            <TextField
              placeholder={option?.placeholder}
              key={users.find(user => user.user === formData.publicKey)?.country}
              rows={option?.rows || 1}
              multiline
              width={option?.width || 50}
              defaultValue={formData[option?.id] || option?.defaultValue}
              onChange={(event) => { updateStateForText(option.id, event.target.value); }}
              onFocus={() => { setSelectedInput(option?.id); }}
              onBlur={e => { trackingAdvancedSettings(option?.id, e.target.value); setSelectedInput(''); }}
              prefix={option?.prefix}
              suffix={option?.suffix}
              maxLength={10000}
              modifier={formData.customErrors?.[option?.id]?.hasError ? 'error' : 'default'}
              helper={option?.helper}
            />
          </>
        )
          : (
            <>
              <div className={`live-settings--snippet-input ${formData.customErrors?.[option?.id]?.hasError ? 'live-settings--snippet-input--error' : ''}`}>
                <pre
                  className="language-javascript line-numbers"
                  alt={i18n.gettext(formData[option?.id])}
                  onClick={() => { setSelectedInput(option?.id); }}
                >
                  <code>
                    {formData[option?.id]}
                  </code>
                </pre>
              </div>
            </>
          )}
        <>
          {
            formData.customErrors?.[option?.id]?.hasError
            && (<div className="live-settings--snippet-input__error-text">
              <div className="live-settings--snippet-input__error-icon">
                <FeedbackCaution16 color="white" />
              </div>
              <p>
                {i18n.gettext(formData.customErrors?.[option?.id].message)}
              </p>
            </div>)
          }
        </>
      </div>
    ),

    title: (option) => (
      <div className={`live-settings-container__title prop-size--${option?.width || 50}`}>
        <span className="live-settings__title">{option?.title}</span>
        <p className="live-settings__title">{option?.label}</p>
      </div>
    ),

    label: (option) => (
      <div className="live-settings-container__label" style={option.style || {}}>
        <span className="live-settings--label">{option?.label}</span>
        {(option?.tooltipContent && !isMobile) && (
          <Tooltip
            className="homologator-header__tooltip"
            content={option?.tooltipContent}
            side="right"
            type="highlight"
            trigger="hover"
            closable
          >
            <Info20 color="var(--andes-color-blue-500)" />
          </Tooltip>
        )}
      </div>
    ),

    twoColumns: (option) => (
      <div className="live-settings-container__two-columns" style={option.style || {}}>
        {settingComponents[option?.items?.[0].type](option?.items?.[0])}
        <div className="live-settings-container__two-columns-divisor" />
        {settingComponents[option?.items?.[1].type](option?.items?.[1])}
      </div>
    ),

    dropdownMulti: (option) => (
      <div className={`live-settings-container__dropdown ${(option?.helperConditionalRender?.length && shouldNotRenderConditionalRenderInput(option?.helperConditionalRender)) ? 'hide-helper' : ''} prop-size--${option.width || 50}`} style={option.style || {}}>
        <Dropdown
          type="form"
          key={users.find(user => user.user === formData.publicKey)?.country}
          label={option?.label}
          placeholder={option?.placeholder}
          defaultValue={option?.defaultValue}
          helper={option?.helper}
          width={option?.width || 50}
          onChange={(event, value) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/select_multiple_${option?.trackingLabel?.toUpperCase()}`, value.toString());
            updateState(option.id, value);
          }}
          multiple
        >
          {
            option?.items.map((item, i) => (
              <DropdownItem
                key={`${item?.value}-${i}`}
                value={item?.value}
                alt={i18n.gettext(item?.primary)}
                title={
                  (
                    <div className="live-settings-container__dropdown-item">
                      {item?.icon && (
                        <div className="live-settings-container__dropdown-item--image-multi">
                          {item?.icon}
                        </div>
                      )}
                      <div className="live-settings-container__dropdown-item--text">
                        <span>{item?.primary}</span>
                      </div>
                    </div>
                  )
                }
              />
            ))
          }
        </Dropdown>
      </div>
    ),

    slider: (option) => (
      <div className={`live-settings-container__slider prop-size--${option?.width || 50}`} style={option.style || {}}>
        <div className="live-settings-slider__tooltip-container">
          <span className="live-settings-slider__tooltip-label">{option?.label}</span>
          {(option?.tooltipContent && !isMobile) && (
            <Tooltip
              className="live-settings-slider__tooltip"
              content={option?.tooltipContent}
              side="right"
              type="highlight"
              trigger="hover"
              showCloseButton
            >
              <Info20 color="var(--andes-color-blue-500)" />
            </Tooltip>
          )}
        </div>
        <Slider
          defaultValue={option?.defaultValue}
          minValue={option?.minValue}
          maxValue={option?.maxValue}
          step={option?.step}
          onChange={(values) => {
            setSliderInput({
              name: option?.trackingLabel,
              value: values[0]?.toString(),
            });
            updateStateForSlider(option.id, values[0]);
          }}
        />
      </div>
    ),

    radioButton: (option) => (
      <div className={`live-settings-container__radio-button prop-size--${option?.width || 50}`} style={option.style || {}}>
        <RadioGroup
          inline={option?.inline || false}
          defaultValue={option?.defaultValue}
          onChange={(value) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/radio_${option?.trackingLabel?.toUpperCase()}`, value);
            updateState(option.id, value);
          }}
        >
          {option?.items.map((item) => (
            <RadioButton
              value={item?.value}
              alt={i18n.gettext(item?.text)}
              text={i18n.gettext(item?.text)}
            />
          ))}
        </RadioGroup>
      </div>
    ),

    checkbox: (option) => (
      <div className={`live-settings-container__checkbox prop-size--${option?.width || 50}`} style={option.style || {}}>
        <Checkbox
          defaultChecked={option?.defaultValue}
          label={option?.label}
          onChange={(event) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/checkbox_${option?.trackingLabel?.toUpperCase()}`, event.target.checked?.toString());
            updateState(option.id, event.target.checked);
          }}
        />
      </div>
    ),

    checkboxList: (option) => (
      <div className={`live-settings-container__checkbox-list prop-size--${option?.width || 50}`} style={option.style || {}}>
        <CheckboxList
          id={option?.id}
          srLabel={option?.label}
          value={formData[option?.id]}
          onChange={(event, selectedValues) => {
            Tracker.send(`mpdevelopers/live_demo/${liveDemoId?.toLowerCase()}/checkbox_list_${option?.trackingLabel?.toUpperCase()}`, selectedValues?.toString());
            updateState(option.id, selectedValues);
          }}
          defaultValue={option.defaultValue}
        >
          {option?.items.map((item, i) => {
            if (item?.conditionalRender?.length && shouldNotRenderConditionalRenderInput(item?.conditionalRender)) return <></>;
            return (<CheckboxListItem
              id={item?.id}
              key={`${item?.value}-${i}`}
              value={item?.value}
              title={item?.title}
            />);
          })}
        </CheckboxList>
      </div>
    ),

    message: (option) => (
      !(behaviorData?.hideComponents?.includes(option?.id)) && (
        <div className={`live-settings-container__message prop-size--${option?.width || 50}`} style={option.style || {}}>
          <Message
            closable={option?.closable}
            type={option?.messageType}
            hierarchy={option?.hierarchy}
            title={option?.title}
          >
            <p>{option?.children}</p>
          </Message>
        </div>
      )
    ),

    // a component that renders a simple line without props
    divider: () => (
      <div className="live-settings-container__divider" />
    ),
  };

  return (
    <div className="live-demo-settings-container">
      <div className="live-demo-summary">
        <span className="live-demo-title">{componentProps?.title}</span>
        <span className="live-demo-description">{componentProps?.description}</span>
      </div>
      <Card className="live-demo-settings-content">
        <GenericCollapse title={optionsDescription} startOpened showHeader={!isMobile && !!advancedOptions} i18n={i18n}>
          {
            options?.map((prop) => (
              <div
                className={`live-demo-settings-content__conditional-render--${(prop?.conditionalRender?.length && shouldNotRenderConditionalRenderInput(prop?.conditionalRender)) ? 'hide' : 'show'}`}
              >
                {settingComponents[prop.type](prop)}
                {prop?.required && shouldRenderRequired(prop) && (
                  <div className="live-demo-settings-content-required-error">
                    <span><FeedbackCaution12 color="white" />{prop?.required?.message}</span>
                  </div>
                )}
              </div>
            ))
          }
        </GenericCollapse>

        {isMobile && (
          <Message color="accent">
            <p>{mobileDescription}</p>
          </Message>
        )}

      </Card>
      {!isMobile && advancedOptions && (
        <Card className="live-demo-settings-content">
          <GenericCollapse title={advancedOptionsDescription} i18n={i18n}>
            {
              advancedOptions?.map((prop) => (
                <div
                  className={`live-demo-settings-content__conditional-render--${(prop?.conditionalRender?.length && shouldNotRenderConditionalRenderInput(prop?.conditionalRender)) ? 'hide' : 'show'}`}
                >
                  {settingComponents[prop.type](prop)}
                </div>
              ))
            }
          </GenericCollapse>
        </Card>
      )}
    </div>
  );
};

module.exports = Properties;
